module.exports = __webpack_public_path__ + "static/img/017_TO8_1478_og.6ade55d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/017_TO8_1478_og.jpg
// module id = 6Fme
// module chunks = 0